import type { Catalog, Category } from "./types";

const aliases: Record<string, string> = {
  "/products": "/subscribe",
  "/me": "/profile",
  "/me/profile": "/profile",
  "/me/orders": "/transaction-record",
  "/auth/login": "/login",
  "/auth/register": "/register",
  "/terms": "/terms-of-service",
  "/privacy": "/privacy-policy",
  "/pay": "/payment/success",
};

// Keep old bookmarks on the same origin; authentication still uses safeNext.
export function storefrontLocation(locationKey: string): string {
  const question = locationKey.indexOf("?");
  const originalPath = (question < 0 ? locationKey : locationKey.slice(0, question))
    .replace(/\/$/, "") || "/";
  const rawQuery = question < 0 ? "" : locationKey.slice(question + 1);
  let path = aliases[originalPath] || originalPath;
  if (/^\/me\/orders\/[^/]+$/.test(originalPath))
    path = originalPath.slice(3);
  const query = new URLSearchParams(rawQuery);
  let changedQuery = false;
  if ((path === "/login" || path === "/register") && !query.has("next") && query.has("redirect")) {
    query.set("next", query.get("redirect") || "");
    changedQuery = true;
  }
  if (path === "/payment/success" && !query.has("order_id") && query.has("order_no")) {
    query.set("order_id", query.get("order_no") || "");
    changedQuery = true;
  }
  const search = changedQuery ? query.toString() : rawQuery;
  return path + (search ? "?" + search : "");
}

export function legacyProductSlug(path: string): string | null {
  const match = /^\/products\/([^/]+)$/.exec(path);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return "";
  }
}

export function productCatalog(catalog: Catalog, slug: string): Catalog {
  const plans = catalog.plans.filter((plan) => plan.productSlug === slug);
  const ids = new Set(plans.map((plan) => plan.categoryId));
  function matchingCategories(categories: Category[]): Category[] {
    return categories.flatMap((category) => {
      const children = matchingCategories(category.children || []);
      return ids.has(category.id) || children.length ? [{ ...category, children }] : [];
    });
  }
  return { ...catalog, plans, categoryTree: matchingCategories(catalog.categoryTree) };
}
